// extracted by mini-css-extract-plugin
export default {"tableContainer":"Finance_tableContainer__CY+UU","tableName":"Finance_tableName__eYzBt"};